import script from "./RotaGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./RotaGrid.vue?vue&type=script&setup=true&lang=js"

import "./RotaGrid.vue?vue&type=style&index=0&id=9afedc48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9afedc48"]])

export default __exports__